import { render, staticRenderFns } from "./FeatureAccessModal.vue?vue&type=template&id=3fcce650&scoped=true&"
import script from "./FeatureAccessModal.vue?vue&type=script&lang=js&"
export * from "./FeatureAccessModal.vue?vue&type=script&lang=js&"
import style0 from "./FeatureAccessModal.vue?vue&type=style&index=0&id=3fcce650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcce650",
  null
  
)

export default component.exports